__turbopack_context__.v({
  "actions": "RedSlider-module__W34ofG__actions",
  "col": "RedSlider-module__W34ofG__col",
  "colCopy": "RedSlider-module__W34ofG__colCopy",
  "colMedia": "RedSlider-module__W34ofG__colMedia",
  "container": "RedSlider-module__W34ofG__container",
  "hero": "RedSlider-module__W34ofG__hero",
  "image": "RedSlider-module__W34ofG__image",
  "imageFrame": "RedSlider-module__W34ofG__imageFrame",
  "row": "RedSlider-module__W34ofG__row",
  "tagline": "RedSlider-module__W34ofG__tagline",
  "title": "RedSlider-module__W34ofG__title",
});
